import { animate, group, query, style, transition, trigger } from '@angular/animations';

/**
 * Fundido entre rutas. Solo la página que sale se saca del flujo: la que entra conserva su
 * altura y su ancho, de modo que el contenedor nunca colapsa durante la transición.
 */
export const fader = trigger('routeAnimations', [
  transition('* <=> *', [
    query(':leave', [style({ position: 'absolute', top: 0, left: 0, width: '100%' })], { optional: true }),
    query(':enter', [style({ opacity: 0 })], { optional: true }),
    group([
      query(':leave', [animate('200ms ease-out', style({ opacity: 0 }))], { optional: true }),
      query(':enter', [animate('300ms ease-out', style({ opacity: 1 }))], { optional: true })
    ])
  ])
]);
